import generateUrl from '../../network/generate-url'

const pagingApiRoutes = {
    addPaging: (baseUrl: string, page: number, pageSize: number, orderBy: string, excelergyLdcAccountNumber: string): string => {
        const params = { page, pageSize, orderBy, excelergyLdcAccountNumber }
        return generateUrl<{ page: number, pageSize: number, orderBy: string, excelergyLdcAccountNumber: string }>(baseUrl, params, false);
    }
}

export default pagingApiRoutes
